import Model, { encoders, ID, Integer, IsoDateTime, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Report from 'src/models/report/Report'

export const DAYS_OF_WEEK_FOR_SELECT = [
  {
    value: 0,
    label: 'Sun'
  },
  {
    value: 1,
    label: 'Mon'
  },
  {
    value: 2,
    label: 'Tue'
  },
  {
    value: 3,
    label: 'Wed'
  },
  {
    value: 4,
    label: 'Thu'
  },
  {
    value: 5,
    label: 'Fri'
  },
  {
    value: 6,
    label: 'Sat'
  }
]

export default class ReportSchedule extends Model {
  static name = 'ReportSchedule'

  static versioned = true

  static deletable = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.OperationsReporting]

  static define () {
    this.fields = {
      id: {
        type: ID
      },

      name: {
        type: String
      },
      enabled: {
        type: Boolean,
        default: true
      },

      report: {
        type: Report,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },

      reportOptions: {
        type: JsonObject,
        default: null
      },
      emails: {
        type: String
      },
      sendSeparateEmails: {
        type: Boolean,
        default: true
      },
      includeCsv: {
        type: Boolean,
        default: true
      },

      hourOfDay: {
        type: Integer,
        default: 0
      },
      daysOfWeek: {
        type: JsonArray,
        default: null
      },
      daysOfMonth: {
        type: JsonArray,
        default: null
      },
      monthsOfYear: {
        type: JsonArray,
        default: null
      },

      lastSentAt: {
        type: IsoDateTime,
        output: true
      }
    }
  }
}
